import { createMuiTheme } from '@material-ui/core/styles'

export default createMuiTheme({
  palette: {
    primary: {
      main: "#455a64",
      light: "#718792",
      dark: "#1c313a",
      contrastText: "#ffffff"
    },
    secondary: {
      main: "#1675d1",
      light: "#62a3ff",
      dark: "#004a9f",
      contrastText: "#ffffff"
    },
    background: {
      default: "#eeeeee"
    }
  }
});


// WEBPACK FOOTER //
// ./src/util/theme.js